
import {
    defineComponent,
    ref,
    onMounted,
    provide,
    inject
} from "vue"
import {
    Search
} from "@element-plus/icons-vue"

//services
import personServ from "@/core/services/PersonService"
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
import Swal from "sweetalert2/dist/sweetalert2.min.js";

//componentes
//import DialogDetails from "./ModalDetails.vue"
//import ModalRegister from "./ModalRegister.vue"
import ModalAddEdit from "./modals/AddEdit.vue"
import PayRollDrawer from "../planilla/components/PayRollDrawer.vue";
import { errManager, showNotification } from "@/core/config/Tools";
import GlobalService from "@/core/services/GlobalService";

export default defineComponent({
    name: "Persons",
    components: {
        ModalAddEdit, PayRollDrawer
    },
    setup() {
        const typeFilter = ref([{
            id: 1,
            name: "ID"
        },
        {
            id: 2,
            name: "Número de documento",
        },
        {
            id: 3,
            name: "Nombre y apellido"
        }
        ])

        const { t } = useI18n();
        const filter = ref({
            option: 2,
            text: ""
        });
        const filterPopoverOpen = ref(false);
        const loading = ref(false);
        const listPersons = ref<any[]>([]);
        const altura = screen.height - 500;
        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0);
        const PayrollDrawerRef = ref<any>(null);
        const rowItem = ref<any>({}); 
        const REPO = ref<string>(process.env.VUE_APP_REPO);
        //pagination end

        //dialogs
        const modalAddEditRef = ref<any>(null)
        const dialog_details = ref(false)

        // variables compartidas
        provide('dialog_details', dialog_details)

        //get variables compartidas
        const gblPersona = inject<any>('gblPersona')

        const getData = async () => {
            loading.value = true
            listPersons.value.slice(0, listPersons.value.length)

            await personServ.getData({
                option: filter.value.option,
                search: filter.value.text,
                pageSize: pageSize.value,
                currentPage: currentPage.value
            })
                .then((res) => {
                    listPersons.value = res.data.data
                    totalItems.value = res.data.total
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false;
                    errManager(response);
                }).finally(() => {
                    loading.value = false
                })
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const openModalDetails = (item) => {
            gblPersona.value = item
            dialog_details.value = true
        }

        const openModalRegister = () => {
            if (modalAddEditRef.value) {
                modalAddEditRef.value.openModal();
            }
        }

        const onPersonResponse = (data) => {
            if (data.status == 'success') {
                getData()
            }

        };

        const handleSizeChange = (val: number) => {
            pageSize.value = val
            getData();
        };

        const onDelete = (row) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: t('deleteText', {text: `<b>${row.firstname} ${row.lastname}</b>`}),
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: t('cancel'),
                confirmButtonText: t('delete'),
                showLoaderOnConfirm: true,
                reverseButtons: true,
                preConfirm: () => {
                    return GlobalService.delete('person', `${row.idperson}/delete`)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification(result.value)
                    result.value.status === 'success' && getData();
                }
            })
        };

        const openDrawerPayroll = (row: any) => {
            if(PayrollDrawerRef.value){
                rowItem.value = row;
                PayrollDrawerRef.value.openDrawer();
            }
        }

        onMounted(() => {
            getData();
        })

        return {
            t,
            REPO,
            moment,
            altura,
            typeFilter,
            filter,
            Search,
            loading,
            listPersons,
            pageSize,
            currentPage,
            totalItems,
            modalAddEditRef,
            PayrollDrawerRef,
            rowItem,
            filterPopoverOpen,
            //events
            getData,
            handleCurrentChange,
            gblPersona,
            dialog_details,
            openModalDetails,
            openModalRegister,
            onPersonResponse,
            handleSizeChange,
            onDelete,
            openDrawerPayroll
        }

    },
})
